export const getAppSettingsBody = (KeysToSearch) => {
    return {
      "Intent": "",
      "Fields": KeysToSearch,
      "Criterion": [],
      "Sort": [],
      "Page": 0,
      "PageSize": 0
    }
  };